<template>
  <div>
    <table-filter
      :filterComponents="[
        {
          type: 'WhereLikeFilter',
          label: 'Benutzername',
          attributes: 'name'
        },
        {
          type: 'DateFilter',
          label: 'Erstellt ab',
          attributes: { column: 'created_at', operator: '>=' }
        },
        {
          type: 'DateFilter',
          label: 'Erstellt bis',
          attributes: { column: 'created_at', operator: '<=' }
        },
        {
          type: 'CheckboxFilter',
          label: 'Erstellt von Admin',
          name: 'admin'
        },
        {
          type: 'CheckboxFilter',
          label: 'Zeige dynamische Fakes',
          attributes: 'has_dynamic_zipcode'
        },
        {
          type: 'CheckboxFilter',
          label: 'Zeige PLZ Fakes',
          attributes: { column: 'has_dynamic_zipcode', operator: '!=' }
        }
      ]"
      v-model="filter"
      @apply-filters="$bus.$emit('refresh-table')"
    ></table-filter>
    <v-table
      url="/api/v1/customerProfile"
      :row-classes="{
        'table-danger': model => {
          return Boolean(model.deleted_at);
        }
      }"
      :filter="filter"
      :appends="['ins', 'outs', 'visits', 'last_out', 'last_circular_mail']"
      :attributes="[
        {
          attribute: 'id',
          name: 'ID'
        },
        {
          type: 'ProfileCell',
          name: 'Profil'
        },
        {
          type: 'CustomerOriginCell',
          name: 'Herkunft'
        },
        {
          name: 'Letztes OUT',
          type: 'DateCell',
          attribute: 'last_out',
          sortable: false
        },
        {
          name: 'Besuche (heute/total)',
          attribute: 'visits',
          sortable: false
        },
        {
          name: 'INs (heute/total)',
          attribute: 'ins',
          sortable: false
        },
        {
          name: 'OUTs (heute/total)',
          attribute: 'outs',
          sortable: false
        },
        {
          attribute: 'created_at',
          name: 'Angelegt am',
          type: 'DateCell'
        },
        {
          attribute: 'user.name',
          name: 'Erstellt von',
          sortable: false
        },
        {
          attribute: 'last_circular_mail',
          name: 'Letzte Rundmail',
          type: 'DateTimeCell',
          sortable: false
        },
        {
          name: 'Aktionen',
          type: 'FakeActionCell'
        }
      ]"
    ></v-table>
  </div>
</template>

<script lang="babel">
export default {
  data () {
    return {
      filter: [
        {
          name: 'fake',
        }
      ]
    };
  }
};
</script>
